module.exports = __webpack_public_path__ + "static/media/GPG116B_H06_RL.550de5d1.jpg";